module.exports = __webpack_public_path__ + "media/reskin-images/icon--frame-70d0dd9b.svg";